import React from 'react'
import { useTranslation } from 'react-i18next'

import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import TableContainer from '@mui/material/TableContainer'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import TableHead from '@mui/material/TableHead'

const kbdStyle = {
  border: '1px solid black',
  fontSize: '18px',
  padding: '4px 8px',
  minWidth: '36px',
  display: 'inline-block',
  textAlign: 'center' as 'center',
  marginRight: '6px',
  marginLeft: '4px',
  borderRadius: '3px',
  boxShadow: '2px 2px 1px rgba(0, 0, 0, 0.3)',
}

interface KeyboardShortcutsModalProps {
  container?: HTMLElement | null
  onClose: () => void
}

const KeyboardShortcutsModal = (props: KeyboardShortcutsModalProps): JSX.Element => {
  const { t } = useTranslation()

  const generateKbdElement = (content: string | JSX.Element): JSX.Element => {
    return <kbd style={kbdStyle}>{content}</kbd>
  }
  const getCommandKey = (): string => {
    return navigator.userAgent.toLowerCase().indexOf('mac') > -1 ? '⌘' : 'Ctrl'
  }

  return (
    <Dialog open={true} onClose={props.onClose} container={props.container} onKeyDown={(e) => e.stopPropagation()}>
      <DialogContent>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell colSpan={2}>{t('editprofileview.keyboardshortcutsheader')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell sx={{ width: '165px' }}>
                  {generateKbdElement(getCommandKey())}+{generateKbdElement('Z')}
                </TableCell>
                <TableCell>{t('editprofileview.undokeyboardshortcuts')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>
                  {generateKbdElement(getCommandKey())}+{generateKbdElement('Y')}
                </TableCell>
                <TableCell>{t('editprofileview.redokeyboardshortcuts')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2}>{t('editprofileview.keyboardshortpointselected')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>{generateKbdElement('Del')}</TableCell>
                <TableCell>{t('editprofileview.deletekeyboardshortcuts')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>{generateKbdElement('←')}</TableCell>
                <TableCell>{t('editprofileview.leftkeyboardshortcuts')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>{generateKbdElement('→')}</TableCell>
                <TableCell>{t('editprofileview.rightkeyboardshortcuts')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>{generateKbdElement('↑')}</TableCell>
                <TableCell>{t('editprofileview.upkeyboardshortcuts')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>{generateKbdElement('↓')}</TableCell>
                <TableCell>{t('editprofileview.downkeyboardshortcuts')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2}>
                  {t('editprofileview.ctrlmovekeyboardshortcutspart1')}
                  {generateKbdElement(getCommandKey())}
                  {t('editprofileview.ctrlmovekeyboardshortcutspart2')}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2}>
                  {t('editprofileview.ctrlmovekeyboardshortcutspart1')}
                  {generateKbdElement('Shift')}
                  {t('editprofileview.shifttoselectmultiple')}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={2}>
                  {t('editprofileview.doubleclickpart1')}
                  {generateKbdElement(getCommandKey())}
                  {t('editprofileview.doubleclickpart2')}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onClose}>{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
  )
}

export default KeyboardShortcutsModal
